const formatComma = (number: number) =>
  number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

export const formatKoreanCompactNumber = (num: number) => {
  if (!num || num === 0) {
    return '0';
  }
  if (num < 10000) {
    return formatComma(num);
  } else if (num < 100000000) {
    const koreanNum = (num / 10000).toFixed(1);
    return koreanNum.replace('.0', '') + '만';
  }

  const koreanNum = (num / 100000000).toFixed(1);
  return koreanNum.replace('.0', '') + '억';
};
